<template>
  <div id="app">
    <div id="nav">
      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>-->
    </div>
    <router-view />
  </div>
</template>


<script>
export default {
  name: "app",
  components: {}
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

body {
  background-color: #f8f8f8;
  background-attachment: fixed;
  background-size: cover;
}

a {
  color: #2a93ac;
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

.uk-button-primary {
  background-color: #2a93ac;
}

.uk-button-primary:hover {
  background-color: #2c3e50;
}

.uk-button-primary:focus {
  background-color: #2a93ac;
}

.uk-progress {
  color: #2c3e50;
}

.uk-button-danger {
  background-color: red;
}

.uk-button-danger:hover {
  background-color: red;
}

.uk-input:focus {
  border-color: #2a93ac;
}

table tr:hover {
  background-color: rgba(48, 158, 181, 0.05);
}

</style>
